import Flickity from 'flickity';

/**
 * SeasonalSentence
 */
export default class SeasonalSentence {
    rootPath = '';
    isLoading = false;
    form =null;
    isTypeModalOpen = false;
    isExperienceModalOpen = false;
    isMonthModalOpen = false;
    typeModalOffset = 0;
    experienceModalOffset = 0;
    monthModalOffset = 0;
    type = null;
    month = '';
    experience = '';
    searchQuery = '';
    searchExperienceQuery ='';
    experiences = [];
    filteredExperiences = [];
    resultsCount = 0;
    resultsCountPanelDocked = false;
    constructor(root, type, experience, month, resultsCount) {
        this.rootPath = root;
        this.type = type;
        this.experience = experience;
        this.month = month;
        this.resultsCount = resultsCount;
    }
    init() {
        this.form = document.getElementById('seasonal-sentence-form');
        this.loadDropdowns();
        this.loadResultsCount();
        this.togglePagination();
        this.setModalPositions();
        this.initCards();
        if (window.addEventListener) {
            window.addEventListener('popstate', () => {
                if (window.history.state === null) {
                    location.reload();
                } else {
                    window.location = window.history.state.path + '&ajax_reload=true';
                }
            });
        }
    }

    /**
     * Loads the dropdown data from the form dataset
     */
    loadDropdowns() {
        this.loadExperiences();
        this.filteredExperiences = this.experiences;
    }

    loadExperiences() {
        try {
            this.experiences = JSON.parse(this.form.dataset.experiences);
        } catch (error) {
            console.error('Error in SeasonalSentence init', error);
            this.experiences = [];
        }
    }

    filterExperiences() {
        const query = this.searchExperienceQuery.toLowerCase();
        if (query) {
            const startsWithQuery = this.experiences.filter(experience =>
                experience.toLowerCase().startsWith(query)
            );
            const includesQuery = this.experiences.filter(experience =>
                !experience.toLowerCase().startsWith(query) &&
                experience.toLowerCase().includes(query)
            );
            this.filteredExperiences = [...startsWithQuery, ...includesQuery];
        } else {
            this.filteredExperiences = this.experiences;
        }
    }

    loadResultsCount() {
        try {
            this.resultsCount = JSON.parse(this.form.dataset.resultsCount);
        } catch (error) {
            console.error('Error in SeasonalSentence init', error);
            this.resultsCount = 0;
        }
    }

    /**
     * Model closing / opening methods
     */
    openTypeModal() {
        this.isTypeModalOpen = true;

        this.setTypeModalPosition();
    }
    closeTypeModal() {
        this.isTypeModalOpen = false;
    }

    openExperienceModal() {
        this.isExperienceModalOpen = true;

        this.setExperienceModalPosition();
    }
    closeExperienceModal() {
        this.isExperienceModalOpen = false;
    }
    openMonthModal() {
        this.isMonthModalOpen = true;

        this.setMonthModalPosition();
    }
    closeMonthModal() {
        this.isMonthModalOpen = false;
    }

    /**
     * Selector methods
     */
    selectType(type) {
        this.type = type;
        this.closeTypeModal();
        setTimeout(() => {
            this.handleSubmit(null);
        }, 100);
    }

    selectExperience(experience) {
        this.experience = experience;
        this.closeExperienceModal();
        setTimeout(() => {
            this.handleSubmit(null);
        }, 100);
    }

    selectMonth(month) {
        this.month = month;
        this.closeMonthModal();
        setTimeout(() => {
            this.handleSubmit(null);
        }, 100);
    }

    getMonthLabel() {
        const months = {
            'jan': 'January',
            'feb': 'February',
            'mar': 'March',
            'apr': 'April',
            'may': 'May',
            'jun': 'June',
            'jul': 'July',
            'aug': 'August',
            'sep': 'September',
            'oct': 'October',
            'nov': 'November',
            'dec': 'December'
        };
        return this.month ? months[this.month] : 'any month';
    }
    getExperienceLabel() {
        return this.experience || 'any experience';
    }

    /**
     * Formatting for experience labels
     * @param experience
     * @returns {*}
     */
    displayExperience(experience) {
        return experience
            .replace(/_/g, ' ')                              // Replace underscores with spaces
            .replace(/\b(?!-)\w/g, l => l.toUpperCase())     // Capitalize first letters except after hyphens
            .replace(/-\w/g, match => match.toLowerCase());  // Ensure letters after hyphens are lowercase
    }

    /**
     * Type dropdown labels
     * @returns {string}
     */
    getTypeLabel() {
        if (this.type === 'all') {
            return 'most popular locations';
        } else {
            return 'most popular locations in ' + this.type;
        }
    }

    /**
     * Form submission. Currently triggered by selecting a dropdown option
     * @param e
     * @param append
     */
    handleSubmit(e, append = false) {
        if (e) {
            e.preventDefault();
        }
        if (!append) {
            this.form.querySelector('input[name="filter-page"]').value = 1;
        }
        const formData = new FormData(this.form);
        const searchParams = new URLSearchParams(formData).toString();
        const url = new URL(window.location.href);
        if (!append) {
            this.fetchContent(url.pathname + '?' + searchParams);
        } else {
            this.fetchMoreContent(url.pathname + '?' + searchParams);
        }
    };

    /**
     * Load more results
     */
    loadMore(e) {
        if (e) {
            e.preventDefault();
        }
        this.form.querySelector('input[name="filter-page"]').value = parseInt(this.form.querySelector('input[name="filter-page"]').value) + 1;
        this.handleSubmit(e, true)
    }

    /**
     * Ajax fetch content
     * @param url
     */
    fetchContent(url) {
        const elements= ['data-pegasus-filterable="filters"', 'data-pegasus-filterable="results"'];
        //show LoadingScreen
        this.isLoading = true;
        const historyUrl = url;
        pegasus.ajaxContent(url, elements, {}, () => {
            this.form = document.getElementById('seasonal-sentence-form');
            this.loadDropdowns();
            this.loadResultsCount();
            this.togglePagination();
            this.pushToHistory(document.title, historyUrl);
            this.initCards();
            this.isLoading = false;
        });
    }

    initCards() {
        const cardCarousels = document.querySelectorAll('.SeasonalSentenceCard__Carousel');

        if (!cardCarousels) return;

        cardCarousels.forEach(cardCarousel => {
            this.carousel = new Flickity(cardCarousel, {
                prevNextButtons: true,
            });
        });
    }

    /**
     * Fetch the content and append it
     * @param url
     */
    fetchMoreContent(url) {
        const elements = ['data-pegasus-filterable="results"'];
        this.isLoading = true;
        const historyUrl = url;
        pegasus.ajaxFetchAndAppendContent(url, elements, {}, () => {
            this.togglePagination();
            this.pushToHistory(document.title, historyUrl);
            this.isLoading = false;
        });
    }

    /**
     * Toggle the visibility of the pagination button
     */
    togglePagination() {
        const p = document.querySelector('.ElasticFilter__Pagination');
        if (!p) return;
        if ((parseInt(this.form.querySelector('input[name="filter-page"]').value) * parseInt(this.form.querySelector('input[name="filter-page_size"]').value)) < parseInt(this.form.querySelector('input[name="total"]').value)) {
            p.style.display = 'block';
        } else {
            p.style.display = 'none';
        }
    }

    /**
     * Check if the browser supports history
     * @returns {boolean}
     */
    historySupported() {
        return !!(window.history && history.pushState);
    }

    /**
     * pushing a title and an url into the history
     * @param title
     * @param url
     */
    pushToHistory(title, url) {
        if (this.historySupported()) {
            history.pushState({ path: url }, title, url);
        }
    }

    /**
     * Returns element right overflow relative to body
     * @param el
     * @returns {number}
     */
    getElementOverflow(el) {
        return el.getBoundingClientRect().left + el.offsetWidth - document.body.clientWidth;
    }

    /**
     * Adjusts all modal positions if off screen
     */
    setModalPositions() {
        this.setTypeModalPosition();
        this.setExperienceModalPosition();
        this.setMonthModalPosition();
    }

    /**
     * Adjusts type modal position if off screen
     */
    setTypeModalPosition() {
        if (!this.$refs?.typeModal) return;

        const rightOverflow = this.getElementOverflow(this.$refs.typeModal);

        this.typeModalOffset = Math.ceil(rightOverflow > 0 ? -rightOverflow : 0);
    }

    /**
     * Adjusts experience modal position if off screen
     */
    setExperienceModalPosition() {
        if (!this.$refs?.experienceModal) return;

        const rightOverflow = this.getElementOverflow(this.$refs.experienceModal);

        this.experienceModalOffset = Math.ceil(rightOverflow > 0 ? -rightOverflow : 0);
    }

    /**
     * Adjusts month modal position if off screen
     */
    setMonthModalPosition() {
        if (!this.$refs?.monthModal) return;

        const rightOverflow = this.getElementOverflow(this.$refs.monthModal);

        this.monthModalOffset = Math.ceil(rightOverflow > 0 ? -rightOverflow : 0);
    }

    /**
     * Scroll to top of screen
     */
    goToTop(e) {
        e.preventDefault();

        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }
}

document.addEventListener('alpine:init', () => {
    Alpine.data('seasonalSentence', (root, type, experience, month, resultsCount) => new SeasonalSentence(root, type, experience, month, resultsCount));
});
